/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type FileDeletionStatus = {
  id: string;
  object: "file";
  deleted: boolean;
};

/** @internal */
export const FileDeletionStatus$inboundSchema: z.ZodType<
  FileDeletionStatus,
  z.ZodTypeDef,
  unknown
> = z.object({
  id: z.string(),
  object: z.literal("file"),
  deleted: z.boolean(),
});
/** @internal */
export type FileDeletionStatus$Outbound = {
  id: string;
  object: "file";
  deleted: boolean;
};

/** @internal */
export const FileDeletionStatus$outboundSchema: z.ZodType<
  FileDeletionStatus$Outbound,
  z.ZodTypeDef,
  FileDeletionStatus
> = z.object({
  id: z.string(),
  object: z.literal("file"),
  deleted: z.boolean(),
});

export function fileDeletionStatusToJSON(
  fileDeletionStatus: FileDeletionStatus,
): string {
  return JSON.stringify(
    FileDeletionStatus$outboundSchema.parse(fileDeletionStatus),
  );
}
export function fileDeletionStatusFromJSON(
  jsonString: string,
): SafeParseResult<FileDeletionStatus, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => FileDeletionStatus$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'FileDeletionStatus' from JSON`,
  );
}
